module.exports = __webpack_public_path__ + "media/partners/ana-979bc794.png";